import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './standby-get-alternative-offers.actions';
import { StandbyGetAlternativeOffersState } from './standby-get-alternative-offers.state';

/**
 * standbyGetAlternativeOffers initial state
 */
export const standbyGetAlternativeOffersInitialState: StandbyGetAlternativeOffersState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for StandbyGetAlternativeOffers Store
 */
export const standbyGetAlternativeOffersReducerFeatures: ReducerTypes<
  StandbyGetAlternativeOffersState,
  ActionCreator[]
>[] = [
  on(actions.setStandbyGetAlternativeOffers, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateStandbyGetAlternativeOffers, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetStandbyGetAlternativeOffers, () => standbyGetAlternativeOffersInitialState),

  on(actions.cancelStandbyGetAlternativeOffersRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failStandbyGetAlternativeOffers, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(
    actions.setStandbyGetAlternativeOffersFromApi,
    actions.updateStandbyGetAlternativeOffersFromApi,
    (state, payload) => asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * StandbyGetAlternativeOffers Store reducer
 */
export const standbyGetAlternativeOffersReducer = createReducer(
  standbyGetAlternativeOffersInitialState,
  ...standbyGetAlternativeOffersReducerFeatures
);
